import React, { useMemo, useState, useEffect } from "react";
import { Link, useParams } from 'react-router-dom';
import { Col, Container, Row, Card, CardBody, NavItem, NavLink, Nav, TabPane, Button, TabContent } from 'reactstrap';
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import axios from "axios";
import classnames from "classnames";
import ParticipantAccountSubProgram from "../Reports/ParticipantAccountSubProgram";
import ProgramParticipantStatusSummary from "../Reports/ProgramParticipantStatusSummary";
import SupplierRedemptionIndex from "../Reports/SupplierRedemptionIndex";
import JournalDetailed from "../Reports/JournalDetail";
import DepositTransfer from "../Reports/DepositTransfer";
import DepositBalance from "../Reports/DepositBalance";
import BudgetComparison from "./BudgetComparison";
import PointsPurchase from "../Reports/PointsPurchase";
import ParticipantAccountSummary from '../Reports/ParticipantAccountSummary'
import UserDetailsChangeLogs from "../Reports/UserDetailsChangeLog";
import DeletedSocialWallPosts from '../Reports/DeletedSocialWallPosts'
import AnnualAwardsSummarySubProgram from "./AnnualAwardsSummary";
import AwardDetailsSummary from "./AwardDetail/index";
import FullCycleAndBreakage from "./FullCycleAndBreakage";
import BillingInformation from "./BillingInformation";
import CoCardAwardDetailsSummary from "./CoCardAwardDetail/index";
import CoCardFundTransfer from "../Reports/CoCardFundTransfer";
import CoCardReport from "../Reports/CoCardReport";
import ScheduleAwardsSummary from "./ScheduleAwardsSummary";

const ProgramReport = ({organization}) => {
  // Tabs Panel
  const [currentActiveTab, setCurrentActiveTab] = useState('1');
  const togglePan = tab => {
    if (currentActiveTab !== tab) setCurrentActiveTab(tab);
  }
  const { programId } = useParams();
  const [program, setProgram] = useState(null);

  const fetchProgramData = async(organization) => {
    try {
      const response = await axios.get(`/organization/${organization.id}/program/${programId}`);
      setProgram(response.data)
    } catch (e) {
      throw new Error(`API error:${e?.message}`);
    }
  };
  useEffect(() => {
    if( organization )  {
      fetchProgramData(organization)
    }
  },[organization, programId])

    const [config, setConfig] = useState(null);

    useEffect(() => {
    axios.get('/config')
        .then(res => setConfig(res.data))
        .catch(() => setConfig({ COCARD_PROGRAM_ID: 0 }));
    }, []);

    if (!config) {
        return <p>Loading config...</p>;
    }
    const COCARD_PROGRAM_ID = config.COCARD_PROGRAM_ID;
  if( !program?.id || !organization?.id )  {
    return 'Loading...'
  }

  return (
    <Container className="dashboard">
    <Row>
      <Col md={12}>
        <h3 className="page-title">Reports</h3>
        <h3 className="page-subhead subhead"><Link className="" to="/">Home</Link> / <Link className="" to="/program">Programs</Link> / <Link className="" to = {`/program/view/${program.id}`}>{program?.name}</Link>/ Reports </h3>
      </Col>
    </Row>
    <Row>
      <Col md={12}>
        <Card>
          <CardBody className='infoview'>
            <Row>
              <Col md="12" >
                <Nav tabs>
                  <NavItem>
                    <NavLink
                        className={classnames({
                          active:
                              currentActiveTab === '1'
                        })}
                        onClick={() => {
                          togglePan('1');
                        }}
                    >
                      Participant Accounts By Subprogram
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                        className={classnames({
                          active:
                              currentActiveTab === '2'
                        })}
                        onClick={() => {
                          togglePan('2');
                        }}
                    >
                      Participant Status Summary
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                        className={classnames({
                          active:
                              currentActiveTab === '3'
                        })}
                        onClick={() => {
                          togglePan('3');
                        }}
                    >
                      Journal Detail
                    </NavLink>
                  </NavItem>
                  <NavLink
                      className={classnames({
                          active:
                              currentActiveTab === '4'
                      })}
                      onClick={() => {
                          togglePan('4');
                      }}
                  >
                      Supplier Redemption
                  </NavLink>
                  <NavLink
                      className={classnames({
                        active:
                            currentActiveTab === '5'
                      })}
                      onClick={() => {
                        togglePan('5');
                      }}
                  >
                    Deposit Transfers
                  </NavLink>
                  <NavLink
                      className={classnames({
                        active:
                            currentActiveTab === '6'
                      })}
                      onClick={() => {
                        togglePan('6');
                      }}
                  >
                    Deposit Balance
                  </NavLink>
                  <NavLink
                      className={classnames({
                        active:
                            currentActiveTab === '7'
                      })}
                      onClick={() => {
                        togglePan('7');
                      }}
                  >
                    Point Purchase Summary
                  </NavLink>
                  <NavLink
                      className={classnames({
                        active:
                            currentActiveTab === '8'
                      })}
                      onClick={() => {
                        togglePan('8');
                      }}
                  >
                    Participant Account Summary
                  </NavLink>
                  <NavLink
                      className={classnames({
                        active:
                            currentActiveTab === '9'
                      })}
                      onClick={() => {
                        togglePan('9');
                      }}
                  >
                    User Detail Change Log
                  </NavLink>
                  <NavLink
                      className={classnames({
                        active:
                            currentActiveTab === '10'
                      })}
                      onClick={() => {
                        togglePan('10');
                      }}
                  >
                      Deleted Social Wall Posts
                  </NavLink>
                  <NavLink
                        className={classnames({
                            active:
                                currentActiveTab === '11'
                        })}
                        onClick={() => {
                            togglePan('11');
                        }}
                    >
                        Budget Comparison
                  </NavLink>
                  <NavLink
                    className={classnames({
                      active:
                        currentActiveTab === '12'
                    })}
                    onClick={() => {
                      togglePan('12');
                    }}
                  >
                    Annual Awards Summary
                  </NavLink>
                  <NavLink
                    className={classnames({
                      active:
                        currentActiveTab === '13'
                    })}
                    onClick={() => {
                      togglePan('13');
                    }}
                  >
                    Award Detailed Report
                  </NavLink>
                  <NavLink
                    className={classnames({
                      active:
                        currentActiveTab === '14'
                    })}
                    onClick={() => {
                      togglePan('14');
                    }}
                  >
                    Full Cycle and Breakage
                  </NavLink>
                  <NavLink
                    className={classnames({
                      active:
                        currentActiveTab === '15'
                    })}
                    onClick={() => {
                      togglePan('15');
                    }}
                  >
                    Billing Information
                  </NavLink>
                  <NavLink
                    className={classnames({
                      active:
                        currentActiveTab === '19'
                    })}
                    onClick={() => {
                      togglePan('19');
                    }}
                  >
                    Schedule Awards Summary
                  </NavLink>
                {Number(program?.id) === Number(COCARD_PROGRAM_ID) && (
                    <>
                        <NavLink
                            className={classnames({
                            active:
                                currentActiveTab === '16'
                            })}
                            onClick={() => {
                            togglePan('16');
                            }}
                        >
                            CoCard Award Details Summary
                        </NavLink>
                        <NavLink
                            className={classnames({
                            active:
                                currentActiveTab === '17'
                            })}
                            onClick={() => {
                            togglePan('17');
                            }}
                        >
                            CoCard Fund Transfers
                        </NavLink>
                        <NavLink
                            className={classnames({
                            active:
                                currentActiveTab === '18'
                            })}
                            onClick={() => {
                            togglePan('18');
                            }}
                        >
                            CoCard Report
                        </NavLink>
                    </>
                )}
                </Nav>
              </Col>
            </Row>
            <TabContent activeTab={currentActiveTab} className="tabContent">
              <TabPane tabId="1" className="tabPane">
                <ParticipantAccountSubProgram program={program}/>
              </TabPane>
              <TabPane tabId="2">
                {
                  currentActiveTab != 2 ? 'Loading...' :
                  <ProgramParticipantStatusSummary program={program}/>
                }
              </TabPane>
              <TabPane tabId="3">
                {
                  currentActiveTab != 3 ? 'Loading...' :
                  <JournalDetailed program={program}/>
                }
              </TabPane>
              <TabPane tabId="4">
                  {
                      currentActiveTab != 4 ? 'Loading...' :
                          <SupplierRedemptionIndex program={program}/>
                  }
              </TabPane>
              <TabPane tabId="5">
                {
                  currentActiveTab != 5 ? 'Loading...' :
                      <DepositTransfer program={program}/>
                }
              </TabPane>
              <TabPane tabId="6">
                {
                  currentActiveTab != 6 ? 'Loading...' :
                      <DepositBalance program={program}/>
                }
              </TabPane>
              <TabPane tabId="7">
                {
                  currentActiveTab != 7 ? 'Loading...' :
                      <PointsPurchase program={program}/>
                }
              </TabPane>
              <TabPane tabId="8">
                {
                  currentActiveTab != 8 ? 'Loading...' :
                      <ParticipantAccountSummary program={program}/>
                }
              </TabPane>
              <TabPane tabId="9">
                {
                  currentActiveTab != 9 ? 'Loading...' :
                      <UserDetailsChangeLogs program={program}/>
                }
              </TabPane>
              <TabPane tabId="10">
                {
                  currentActiveTab != 10 ? 'Loading...' :
                      <DeletedSocialWallPosts program={program}/>
                }
              </TabPane>
              <TabPane tabId="11">
                {
                    currentActiveTab != 11 ? 'Loading...' :
                        <BudgetComparison program={program}/>
                }
              </TabPane>
              <TabPane tabId="12">
                {
                  currentActiveTab != 12 ? 'Loading...' :
                    <AnnualAwardsSummarySubProgram program={program}/>
                }
              </TabPane>
              <TabPane tabId="13">
                {
                  currentActiveTab != 13 ? 'Loading...' :
                    <AwardDetailsSummary program={program}/>
                }
              </TabPane>
              <TabPane tabId="14">
                {
                  currentActiveTab != 14 ? 'Loading...' :
                    <FullCycleAndBreakage program={program}/>
                }
              </TabPane>
              <TabPane tabId="15">
                {
                  currentActiveTab != 15 ? 'Loading...' :
                    <BillingInformation program={program}/>
                }
              </TabPane>
              <TabPane tabId="19">
                {
                  currentActiveTab != 19 ? 'Loading...' :
                    <ScheduleAwardsSummary program={program}/>
                }
              </TabPane>
            {Number(program?.id) === Number(COCARD_PROGRAM_ID) && (
                <>
                    <TabPane tabId="16">
                    {currentActiveTab !== '16' ? 'Loading...' : (
                        <CoCardAwardDetailsSummary program={program} />
                    )}
                    </TabPane>
                    <TabPane tabId="17">
                        {
                        currentActiveTab != 17 ? 'Loading...' :
                            <CoCardFundTransfer program={program}/>
                        }
                    </TabPane>
                    <TabPane tabId="18">
                        {currentActiveTab !== '18' ? 'Loading...' : (
                            <CoCardReport program={program} />
                        )}
                    </TabPane>
                </>
            )}
            </TabContent>
          </CardBody>
        </Card>
      </Col>
    </Row>
  </Container>
  )
}

export default withRouter(connect((state) => ({
  organization: state.organization
}))(ProgramReport));
